import {
  Info as TheIcon
} from 'components/icons';

// OR
// import React from 'react';
// import { Icon } from "semantic-ui-react";

// function TheIcon (props) {
//   return <Icon name="info" {...props} />;
// }

export const meta = {
  id: 'GraphiQL',
  title: 'GraphiQL',
  category: 'Engineering',
  exposes: [
    {
      title: 'GraphiQL',
      action: { module: 'GraphiQL', props: { /* */ } },
      desription: 'general-desc',
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Try graphql queries within amos`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
